"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deserializeNumber_1 = require("./deserializeNumber");
function deserializeLongitude(value) {
    return (0, deserializeNumber_1.deserializeNumber)(value, -180, 180);
}
exports.default = deserializeLongitude;
